import Logger from "./LoggerContainer";

export default Logger;
